export class Transaction {
  constructor (params = {}) {
    this.amount = params.amount
    this.paymentMethodId = params.paymentMethodId
    this.currencyId = params.currencyId
    this.type = params.type
    this.accountId = params.accountId
    this.concept = params.concept
    this.operatorId = params.operatorId
    this.guestId = params.guestId
    this.attributes = params.attributes
    this.exchangeCurrencyId = params.exchangeCurrencyId
    this.exchangeRate = params.exchangeRate
    this.stationId = params.stationId
  }
  serialize () {
    var body = {
      amount: this.amount,
      currency_id: this.currencyId,
      account_id: this.accountId,
      type: this.type,
      concept: this.concept,
      operator_id: this.operatorId,
      moment: new Date(),
      guest_id: this.guestId,
      attributes: this.attributes,
      exchange_currency_id: this.exchangeCurrencyId,
      exchange_value: this.exchangeRate,
      station_id: this.stationId
    }
    if (this.type === 'PAYMENT') {
      body.payment_method_id = this.paymentMethodId
    }
    return body
  }
}
